import React, { useEffect, useMemo, useState } from "react";
import {
  Card,
  Row,
  Col,
  Spinner,
} from "react-bootstrap";
import CountUp from "react-countup";

import DashboardService from "../../../services/pbumku/DashboardService";
import { usePeriode } from "../context/PeriodeContext";

export default function ReportPasca() {
  const DashService = useMemo(() => new DashboardService(), []);

  const { periode } = usePeriode();
  const { startDate, endDate } = periode;
  const yearPeriod = startDate ? startDate.split("-")[0] : new Date().getFullYear();

  const [loading, setLoading] = useState(true);

  const [totalSKP, setTotalSKP] = useState(0);

  const [haccp, setHaccp] = useState({
    A: 0,
    B: 0,
    C: 0,
    JUMLAH: 0,
  });


  const safeParse = (value) => {
    if (
      value === null ||
      value === undefined ||
      value === ""
    ) {
      return 0;
    }

    const parsed = Number(
      String(value).replace(/[^0-9.-]/g, "")
    );

    return Number.isNaN(parsed) ? 0 : parsed;
  };


  useEffect(() => {
    const fetchData = async () => {
      if (!startDate || !endDate) return;

      try {
        setLoading(true);

        const awal = startDate;
        const akhir = endDate;

        const [
          responseSKP,
        responseHACCP,
      ] = await Promise.all([
        DashService.getResumeSKP(
          awal,
          akhir
        ),


        DashService.getJumlahHACCP(
          awal,
          akhir
        ),
      ]);

      const dataSKP =
        responseSKP?.data?.data ??
        responseSKP?.data ??
        {};

      console.log(
        "RESUME SKP:",
        dataSKP
      );

      const jumlahSKP =
        dataSKP?.totalSKP ??
        dataSKP?.total_skp ??
        dataSKP?.sertifikat ??
        dataSKP?.jumlah ??
        dataSKP?.total ??
        0;

      setTotalSKP(
        safeParse(jumlahSKP)
      );

      const dataHACCP =
        responseHACCP?.data?.data ??
        responseHACCP?.data ??
        {};

      const gradeA = safeParse(
        dataHACCP?.A
      );

      const gradeB = safeParse(
        dataHACCP?.B
      );

      const gradeC = safeParse(
        dataHACCP?.C
      );

      const jumlahHACCP =
        safeParse(
          dataHACCP?.JUMLAH
        );

      setHaccp({
        A: gradeA,
        B: gradeB,
        C: gradeC,

        JUMLAH:
          jumlahHACCP > 0
            ? jumlahHACCP
            : gradeA +
              gradeB +
              gradeC,
      });
    } catch (error) {
      console.error(
        "Gagal mengambil data Pascapanen:",
        error
      );

      setTotalSKP(0);

      setHaccp({
        A: 0,
        B: 0,
        C: 0,
        JUMLAH: 0,
      });
    } finally {
      setLoading(false);
    }
  };

  fetchData();
  }, [DashService, startDate, endDate]);

  const kpiStyle = {
    borderRadius: "12px",
    transition: "all 0.2s ease",
  };

  return (
    <Card className="border-0 shadow-sm rounded-4 mb-4">
      <Card.Header className="bg-white border-0 px-4 pt-4 pb-2">
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3">
          <div>
            {/* <div
              className="text-uppercase fw-semibold mb-1"
              style={{
                fontSize: "11px",
                letterSpacing: "1px",
                color: "#0071CE",
              }}
            >
              Sertifikasi Mutu Pascapanen
            </div> */}

          <h6 className="fw-bold text-uppercase mb-1">
            Rekap Sertifikasi Mutu Pascapanen
            </h6>

            <small className="text-muted">
              Periode Tahun {yearPeriod}
            </small>
          </div>

        </div>
      </Card.Header>

      <Card.Body className="px-4 pb-4 pt-3">
        {loading ? (
          <div
            className="d-flex flex-column justify-content-center align-items-center"
            style={{
              minHeight: "230px",
            }}
          >
            <Spinner
              animation="border"
              size="sm"
              variant="primary"
            />

            <span className="text-muted small mt-3">
              Memuat data sertifikasi...
            </span>
          </div>
        ) : (
          <Row className="g-4">

            <Col
              xs={12}
              lg={4}
            >
              <div className="h-100">
                {/* JUDUL */}
                <div className="d-flex align-items-center mb-2">
                  <div
                    style={{
                      width: "4px",
                      height: "18px",
                      borderRadius:
                        "10px",
                      backgroundColor:
                        "#0071CE",
                      marginRight:
                        "8px",
                    }}
                  />

                  <h6 className="fw-bold mb-0">
                    Sertifikasi SKP
                  </h6>
                </div>

                {/* TOTAL SKP */}
                <div
                  className="h-100 d-flex flex-column justify-content-center align-items-center text-center"
                  style={{
                    ...kpiStyle,

                    minHeight: "175px",

                    background:
                      "linear-gradient(135deg, #0071CE 0%, #005A9E 100%)",

                    padding:
                      "24px 20px",

                    boxShadow:
                      "0 6px 18px rgba(0, 113, 206, 0.15)",
                  }}
                >
                  <div
                    className="text-white text-uppercase mb-2"
                    style={{
                      fontSize:
                        "12px",
                      letterSpacing:
                        ".8px",
                      opacity: 0.85,
                    }}
                  >
                    Total SKP Terbit
                  </div>

                  <div
                    className="fw-bold text-white"
                    style={{
                      fontSize:
                        "38px",
                      lineHeight: 1.1,
                    }}
                  >
                    <CountUp
                      end={totalSKP}
                      duration={1.4}
                      separator="."
                    />
                  </div>

                  <small
                    className="text-white mt-2"
                    style={{
                      opacity: 0.8,
                    }}
                  >
                    Sertifikat
                  </small>
                </div>
              </div>
            </Col>

            {/* Total HACCP  */}
            <Col
              xs={12}
              lg={8}
            >
              <div>
                {/* JUDUL */}
                <div className="d-flex align-items-center mb-2">
                  <div
                    style={{
                      width: "4px",
                      height: "18px",
                      borderRadius:
                        "10px",
                      backgroundColor:
                        "#F7941E",
                      marginRight:
                        "8px",
                    }}
                  />

                  <h6 className="fw-bold mb-0">
                    Sertifikasi HACCP
                  </h6>
                </div> 

                <div
                  className="d-flex justify-content-between align-items-center mb-3"
                  style={{
                    ...kpiStyle,

                    minHeight: "82px",

                    padding:
                      "16px 22px",

                    background:
                      "linear-gradient(135deg, #176B87 0%, #0F526A 100%)",

                    boxShadow:
                      "0 6px 18px rgba(23, 107, 135, 0.15)",
                  }}
                >
                  <div>
                    <div
                      className="text-white text-uppercase mb-1"
                      style={{
                        fontSize:
                          "11px",
                        letterSpacing:
                          ".8px",
                        opacity: 0.8,
                      }}
                    >
                      Total Sertifikat
                    </div>

                    <div className="text-white fw-semibold">
                      TOTAL HACCP
                    </div>
                  </div>

                  <div
                    className="text-white fw-bold"
                    style={{
                      fontSize:
                        "34px",
                    }}
                  >
                    <CountUp
                      end={
                        haccp.JUMLAH
                      }
                      duration={1.4}
                      separator="."
                    />
                  </div>
                </div>
                
                <Row className="g-3">
                  {/* GRADE A */}
                  <Col
                    xs={12}
                    sm={4}
                  >
                    <div
                      className="text-center"
                      style={{
                        ...kpiStyle,

                        padding:
                          "18px 10px",

                        backgroundColor:
                          "#EFF7FF",

                        border:
                          "1px solid #CFE8FF",
                      }}
                    >
                      <div
                        className="fw-semibold mb-2"
                        style={{
                          color:
                            "#0071CE",
                          fontSize:
                            "13px",
                        }}
                      >
                        Grade A
                      </div>

                      <div
                        className="fw-bold"
                        style={{
                          color:
                            "#0071CE",
                          fontSize:
                            "26px",
                        }}
                      >
                        <CountUp
                          end={
                            haccp.A
                          }
                          duration={
                            1.4
                          }
                          separator="."
                        />
                      </div>
                    </div>
                  </Col>

                  {/* GRADE B */}
                  <Col
                    xs={12}
                    sm={4}
                  >
                    <div
                      className="text-center"
                      style={{
                        ...kpiStyle,

                        padding:
                          "18px 10px",

                        backgroundColor:
                          "#FFF7ED",

                        border:
                          "1px solid #FFE2BD",
                      }}
                    >
                      <div
                        className="fw-semibold mb-2"
                        style={{
                          color:
                            "#F7941E",
                          fontSize:
                            "13px",
                        }}
                      >
                        Grade B
                      </div>

                      <div
                        className="fw-bold"
                        style={{
                          color:
                            "#F7941E",
                          fontSize:
                            "26px",
                        }}
                      >
                        <CountUp
                          end={
                            haccp.B
                          }
                          duration={
                            1.4
                          }
                          separator="."
                        />
                      </div>
                    </div>
                  </Col>

                  {/* GRADE C */}
                  <Col
                    xs={12}
                    sm={4}
                  >
                    <div
                      className="text-center"
                      style={{
                        ...kpiStyle,

                        padding:
                          "18px 10px",

                        backgroundColor:
                          "#EFF9F5",

                        border:
                          "1px solid #CDE9E0",
                      }}
                    >
                      <div
                        className="fw-semibold mb-2"
                        style={{
                          color:
                            "#4BA38A",
                          fontSize:
                            "13px",
                        }}
                      >
                        Grade C
                      </div>

                      <div
                        className="fw-bold"
                        style={{
                          color:
                            "#4BA38A",
                          fontSize:
                            "26px",
                        }}
                      >
                        <CountUp
                          end={
                            haccp.C
                          }
                          duration={
                            1.4
                          }
                          separator="."
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        )}
      </Card.Body>
    </Card>
  );
}